module.exports = __webpack_public_path__ + "img/model6_zh.796bc831.jpg";